export default __webpack_public_path__ + "static/media/slid1.c743fdf8.jpg";